import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from '@mui/material';
import { FilterList as FilterIcon } from '@mui/icons-material';

const FilterPanel = ({ filters, onFilterChange }) => {
  const handleChange = (filterName, value) => {
    onFilterChange({ ...filters, [filterName]: value });
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
      {/* Status Filter */}
      {filters.status !== undefined && (
        <FormControl sx={{ minWidth: 150 }} size="small">
          <InputLabel>Status</InputLabel>
          <Select
            value={filters.status || 'all'}
            label="Status"
            onChange={(e) => handleChange('status', e.target.value)}
          >
            <MenuItem value="all">All Status</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="completed">Completed</MenuItem>
            <MenuItem value="cancelled">Cancelled</MenuItem>
            <MenuItem value="estimate">Draft</MenuItem>
            <MenuItem value="pending_approval">Pending Approval</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
          </Select>
        </FormControl>
      )}

      {/* Sort Filter */}
      {filters.sort !== undefined && (
        <FormControl sx={{ minWidth: 150 }} size="small">
          <InputLabel>Sort By</InputLabel>
          <Select
            value={filters.sort || 'created_at'}
            label="Sort By"
            onChange={(e) => handleChange('sort', e.target.value)}
          >
            <MenuItem value="created_at">Newest First</MenuItem>
            <MenuItem value="name">Name (A-Z)</MenuItem>
            <MenuItem value="status">Status</MenuItem>
            {filters.sort_cost && <MenuItem value="total_cost">Total Cost</MenuItem>}
          </Select>
        </FormControl>
      )}

      {/* Order Filter */}
      {filters.order !== undefined && filters.sort && filters.sort !== 'created_at' && (
        <FormControl sx={{ minWidth: 120 }} size="small">
          <InputLabel>Order</InputLabel>
          <Select
            value={filters.order || 'desc'}
            label="Order"
            onChange={(e) => handleChange('order', e.target.value)}
          >
            <MenuItem value="asc">Ascending</MenuItem>
            <MenuItem value="desc">Descending</MenuItem>
          </Select>
        </FormControl>
      )}

      {/* Active Filters Display */}
      {(filters.status && filters.status !== 'all') && (
        <Chip
          icon={<FilterIcon />}
          label={`Status: ${filters.status}`}
          onDelete={() => handleChange('status', 'all')}
          color="primary"
          variant="outlined"
        />
      )}
    </Box>
  );
};

export default FilterPanel;
